export default __webpack_public_path__ + "static/dps-icon-368220acaf87715db98d39e4c8ce03be.png";